import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
} from '@angular/core';

@Component({
    selector: 'lokos-pagination',
    templateUrl: './pagination.component.html',
    styleUrl: './pagination.component.scss',
    standalone: false,
})
export class PaginationComponent implements OnChanges {
    @Input() total = 0;
    @Input() page = 1;
    @Input() pageSize = 10;
    @Input() pageSizes: number[] = [10, 25, 50, 100];

    @Output() pageChange = new EventEmitter<number>();
    @Output() pageSizeChange = new EventEmitter<number>();

    pageSizeOpen = false;
    visiblePages: number[] = [];

    ngOnChanges(_changes: SimpleChanges): void {
        this.computeVisiblePages();
    }

    get totalPages(): number {
        return Math.max(1, Math.ceil(this.total / this.pageSize));
    }

    get rangeFrom(): number {
        if (this.total === 0) return 0;
        return (this.page - 1) * this.pageSize + 1;
    }

    get rangeTo(): number {
        return Math.min(this.page * this.pageSize, this.total);
    }

    computeVisiblePages() {
        const total = this.totalPages;
        const current = this.page;
        if (total <= 7) {
            this.visiblePages = Array.from({ length: total }, (_, i) => i + 1);
            return;
        }
        if (current <= 4) {
            this.visiblePages = [1, 2, 3, 4, 5, -1, total];
            return;
        }
        if (current >= total - 3) {
            this.visiblePages = [
                1,
                -1,
                total - 4,
                total - 3,
                total - 2,
                total - 1,
                total,
            ];
            return;
        }
        this.visiblePages = [
            1,
            -1,
            current - 1,
            current,
            current + 1,
            -1,
            total,
        ];
    }

    goTo(page: number) {
        if (page < 1 || page > this.totalPages || page === this.page) return;
        this.pageChange.emit(page);
    }

    onPageSizeSelect(size: number) {
        this.pageSizeOpen = false;
        if (size !== this.pageSize) {
            this.pageSizeChange.emit(size);
        }
    }

    togglePageSize() {
        this.pageSizeOpen = !this.pageSizeOpen;
    }
}
